import EditIcon from "@mui/icons-material/EditOutlined";
import { useContext, useEffect, useState } from "react";
import SettingsSection from "../../../shared/components/SettingsSection";
import {
  ActionButton,
  TableActions,
  TableCell,
  TableRow,
} from "../../../shared/components/table/StyledTable";
import { PartitionKeyEnum } from "../../../shared/enums";
import ConfigDataProvider, {
  ConfigDataContext,
} from "../../../shared/providers/ConfigDataProvider";
import { GET_CONFIG_DATA } from "../../../shared/reducer/configDataReducer";
import { formatCurrency } from "../../../shared/utils";
import ProductPricesDialog from "./ProductPricesDialog";

const ProductPrices = () => (
  <ConfigDataProvider>
    <ProductPricesConsumer />
  </ConfigDataProvider>
);

/**
 * Table displaying CRUD possible product prices
 */
const ProductPricesConsumer = () => {
  // Load reducer
  const { state, dispatch } = useContext(ConfigDataContext);

  useEffect(() => {
    dispatch({ type: GET_CONFIG_DATA, id: "BasePrice" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Dialog/current id being edited state and handlers
  const [dialogOpen, setDialogOpen] = useState(false);
  const [partitionKey, setPartitionKey] = useState<string>("");
  const handleOpenDialog = (nextPartitionKey: string) => {
    setPartitionKey(nextPartitionKey);
    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setPartitionKey("");
    setDialogOpen(false);
  };

  const prices = state?.data ? Object.entries(state.data) : [];

  return (
    <>
      <SettingsSection
        title="Produktpreise"
        description="Grundpreis je Produkt"
        columns={["Produkt", "Preis"]}
        isEmpty={!prices.length}
        emptyMessage="Noch keine Preise hinterlegt."
      >
        {prices.map(([key, price]: any) => (
          <TableRow key={key}>
            <TableCell sx={{ fontWeight: 600 }}>
              {
                //@ts-ignore - TS does not like using strings as enum property references
                PartitionKeyEnum[key]
              }
            </TableCell>
            <TableCell>{formatCurrency(price)}</TableCell>
            <TableCell align="right">
              <TableActions>
                <ActionButton
                  icon={<EditIcon />}
                  label="Preis bearbeiten"
                  onClick={() => handleOpenDialog(key)}
                />
              </TableActions>
            </TableCell>
          </TableRow>
        ))}
      </SettingsSection>

      {dialogOpen && (
        <ProductPricesDialog
          partitionKey={partitionKey}
          handleCloseDialog={handleCloseDialog}
        />
      )}
    </>
  );
};

export default ProductPrices;
